import { getLandedUSD, getBaseLanded, getOffPriceWS, getOffPriceCalcRRP, getOffPriceRRP, getOffPriceMargin, getStdWS, getStdCalcRRP, getStdRRP, getStdRRPexVAT, getStdMargin, getTRCalcRRP, getTRRRP, getTRSupply, getTRMargin, getD2CRRP, getD2CCostNoPP, getD2CCostWithPP, getD2CMarginNoPP, getD2CMarginFreePP, getD2C10PctRRP, getD2C10PctRRPexVAT, getD2C10MarginNoPP, getD2C10MarginFreePP, getD2C30PctRRP, getD2C30PctRRPexVAT, getD2C30MarginNoPP, getD2C30MarginFreePP, getDuty, getStockTotal, formatPct, DEFAULT_SETTINGS } from './pricing'

function escapeCSV(val) {
  return '"' + String(val || '').replace(/"/g, '""') + '"'
}

export function exportToCSV(products, currency = 'GBP', settings = DEFAULT_SETTINGS, filename = 'yvg-catalogue') {
  const rows = [['YVG SKU','Brand','EAN Code','Product Type','Gender','Country of Origin','Factory SKU','Specification','Factory Cost','Packaging','Duty','Freight','Landed USD','Landed '+currency,'OP WS '+currency,'OP RRP '+currency,'OP Margin','Std WS '+currency,'Std RRP '+currency,'Std RRP ExVAT '+currency,'Std Margin','TR RRP '+currency,'TR Supply '+currency,'TR Margin','D2C RRP '+currency,'D2C Margin No PP','D2C Margin Free PP','10% Disc RRP','30% Disc RRP','UK Stock','DE Stock','Total Stock','Packshot URL','Model Image URL']]
  products.forEach(p => {
    rows.push([p.sku,p.brand,p.ean_code,p.product_type,p.gender,p.country_of_origin,p.factory_sku,p.specification,p.factory_cost,p.packaging_cost,getDuty(p).toFixed(2),p.freight,getLandedUSD(p).toFixed(2),getBaseLanded(p,currency,settings).toFixed(2),getOffPriceWS(p,currency,settings).toFixed(2),getOffPriceRRP(p,currency,settings),formatPct(getOffPriceMargin(p,currency,settings)),getStdWS(p,currency,settings).toFixed(2),getStdRRP(p,currency,settings),getStdRRPexVAT(p,currency,settings).toFixed(2),formatPct(getStdMargin(p,currency,settings)),getTRRRP(p,currency,settings),getTRSupply(p,currency,settings).toFixed(2),formatPct(getTRMargin(p,currency,settings)),getD2CRRP(p,currency,settings),formatPct(getD2CMarginNoPP(p,currency,settings)),formatPct(getD2CMarginFreePP(p,currency,settings)),getD2C10PctRRP(p,currency,settings).toFixed(2),getD2C30PctRRP(p,currency,settings).toFixed(2),p.stock_uk||0,p.stock_de||0,getStockTotal(p),p.packshot_image||'',p.model_image||''])
  })
  const csv = rows.map(r => r.map(escapeCSV).join(',')).join('\n')
  const blob = new Blob([csv], { type: 'text/csv' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename + '-' + currency + '-' + new Date().toISOString().split('T')[0] + '.csv'
  a.click()
  URL.revokeObjectURL(url)
}

export function parseCSVImport(text) {
  const lines = text.split('\n').filter(l => l.trim())
  if (lines.length < 2) return []
  const headers = lines[0].split(',').map(h => h.replace(/^"|"$/g, '').trim().toLowerCase())
  const idx = name => headers.findIndex(h => h.includes(name))
  const fieldMap = {
    sku: idx('yvg sku'),
    brand: idx('brand'),
    ean_code: idx('ean code'),
    hts_code: idx('hts code'),
    trex: idx('trex'),
    factory_moq: idx('factory moq'),
    msds_sheet: idx('msds'),
    user_manual: idx('user manual'),
    product_type: idx('product type'),
    gender: idx('gender'),
    country_of_origin: idx('country of origin'),
    factory_sku: idx('factory sku'),
    production_time_weeks: idx('production time'),
    reference_image: idx('reference image'),
    packshot_image: idx('packshot image'),
    model_image: idx('model image'),
    case_size_mm: idx('case size mm'),
    movement_model: idx('movement model'),
    battery: idx('battery'),
    size_mm: idx('size mm'),
    product_weight: idx('product weight'),
    weight_including_packaging: idx('weight including'),
    packaging_sku: idx('packaging sku'),
    packaging_dimensions: idx('packaging dim'),
    packaging_instructions: idx('packaging inst'),
    packaging_eco_friendly: idx('eco-friendly'),
    qty_per_case: idx('qty per case'),
    case_size_cm: idx('case size cm'),
    specification: idx('specification'),
    base_metal: idx('basemetal'),
    plating_type: idx('plating type'),
    stone_gemstone: idx('stone'),
    description_en: idx('description english'),
    description_de: idx('description german'),
    description_es: idx('description spanish'),
    description_fr: idx('description french'),
    stock_uk: idx('flostream uk'),
    stock_de: idx('flostream germany'),
    factory_cost: idx('factory cost'),
    packaging_cost: idx('packaging'),
    freight: idx('freight'),
  }
  return lines.slice(1).map(line => {
    const cols = []
    let inQ = false, cur = ''
    for (let i = 0; i < line.length; i++) {
      const ch = line[i]
      if (ch === '"') { inQ = !inQ }
      else if (ch === ',' && !inQ) { cols.push(cur.trim()); cur = '' }
      else cur += ch
    }
    cols.push(cur.trim())
    const get = i => i >= 0 ? (cols[i] || '').replace(/^"|"$/g, '').trim() : ''
    const getNum = (i, d = 0) => parseFloat(get(i)) || d
    const sku = get(fieldMap.sku)
    if (!sku) return null
    return {
      sku,
      supplier_code: '',
      brand: get(fieldMap.brand) || 'Unknown',
      ean_code: get(fieldMap.ean_code),
      hts_code: get(fieldMap.hts_code),
      trex: get(fieldMap.trex),
      factory_moq: get(fieldMap.factory_moq),
      msds_sheet: get(fieldMap.msds_sheet),
      user_manual: get(fieldMap.user_manual),
      product_type: get(fieldMap.product_type) || 'Watch',
      gender: get(fieldMap.gender) || 'Male',
      country_of_origin: get(fieldMap.country_of_origin) || 'China',
      factory_sku: get(fieldMap.factory_sku),
      production_time_weeks: getNum(fieldMap.production_time_weeks, 6),
      reference_image: get(fieldMap.reference_image),
      packshot_image: get(fieldMap.packshot_image),
      model_image: get(fieldMap.model_image),
      case_size_mm: get(fieldMap.case_size_mm),
      movement_model: get(fieldMap.movement_model),
      battery: get(fieldMap.battery),
      size_mm: get(fieldMap.size_mm),
      product_weight: get(fieldMap.product_weight),
      weight_including_packaging: get(fieldMap.weight_including_packaging),
      packaging_sku: get(fieldMap.packaging_sku),
      packaging_dimensions: get(fieldMap.packaging_dimensions),
      packaging_instructions: get(fieldMap.packaging_instructions),
      packaging_eco_friendly: get(fieldMap.packaging_eco_friendly) === 'Y',
      qty_per_case: get(fieldMap.qty_per_case),
      case_size_cm: get(fieldMap.case_size_cm),
      specification: get(fieldMap.specification),
      base_metal: get(fieldMap.base_metal),
      plating_type: get(fieldMap.plating_type),
      stone_gemstone: get(fieldMap.stone_gemstone),
      description_en: get(fieldMap.description_en),
      description_de: get(fieldMap.description_de),
      description_es: get(fieldMap.description_es),
      description_fr: get(fieldMap.description_fr),
      stock_uk: getNum(fieldMap.stock_uk),
      stock_de: getNum(fieldMap.stock_de),
      factory_cost: getNum(fieldMap.factory_cost),
      packaging_cost: getNum(fieldMap.packaging_cost, 1.4),
      freight: getNum(fieldMap.freight, 0.3),
      avg_weekly_sales: 2,
    }
  }).filter(Boolean)
}
